<template>
  <main>
    <InputFilter class="pt-10" :pagination="pagination" />
    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="10" class="mx-auto py-0">
            <v-row justify="space-between" no-gutters>
              <v-col cols="12" sm="2" class="camp-type">
                <v-select
                  :items="camp_types"
                  item-text="name"
                  item-value="id"
                  label="Camp Types"
                  dense
                  filled
                  clearable
                  v-model="filter.type"
                  @change="filterCamp"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="month">
                <v-select
                  :items="months"
                  item-text="num"
                  item-value="num"
                  label="Month"
                  filled
                  dense
                  clearable
                  v-model="filter.month"
                  @change="filterMonths"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="year">
                <v-select
                  :items="yearsList"
                  item-text="year"
                  item-value="year"
                  label="Year"
                  filled
                  dense
                  clearable
                  v-model="filter.year"
                  @change="filterYears"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="location">
                <v-autocomplete
                  :items="camp_locations"
                  item-text="name"
                  item-value="id"
                  label="Location"
                  filled
                  dense
                  clearable
                  v-model="filter.location"
                  @change="filterLocation"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" class="gender">
                <v-select
                  :items="availableArray"
                  item-text="name"
                  item-value="name"
                  label="Availability"
                  filled
                  dense
                  v-model="filter.available"
                  @change="filterAvailability"
                  :append-icon="filter.available ? 'mdi-close' : ''"
                  @click:append="clearSearchData('available')"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>Camps</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_camps')"
          class="main-header__contents"
        >
          <v-btn
            class="radius-12 my-auto mx-1"
            color="success"
            to="/camps/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add Camp</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="camps"
        :loading="loadingCamps"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <template v-slot:item="camp">
          <tr class="table__row">
            <td class="table__cell text-center transparent-field">
              <v-checkbox
                :disabled="
                  !permissions.includes('update_api_admin-panel_camps_{camp}')
                "
                v-model="camp.item.available"
                color="warning"
                @change="campVisiblity(camp)"
              ></v-checkbox>
            </td>
            <td class="table__cell text-center name">{{ camp.item.name }}</td>
            <td class="table__cell text-center">{{ camp.item.type_name }}</td>
            <td class="table__cell text-center">
              {{ camp.item.location.location }}
            </td>
            <td class="table__cell text-center">
              {{ camp.item.start_date.date | moment("Do,MMM' YYYY") }}
            </td>
            <td class="table__cell text-center">
              {{ camp.item.end_date.date | moment("Do,MMM' YYYY") }}
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!camp.item.online_payment"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-avatar left>
                  <v-icon small>mdi-close-circle</v-icon>
                </v-avatar>
                Closed
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-avatar left>
                  <v-icon small>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Open
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!camp.item.cashondelivery_payment"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-avatar left>
                  <v-icon small>mdi-close-circle</v-icon>
                </v-avatar>
                Closed
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-avatar left>
                  <v-icon small>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Open
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <router-link :to="`/camps/${camp.item.id}/teams`">
                <v-icon>mdi-account-multiple</v-icon>
              </router-link>
            </td>
            <td class="table__cell text-center">
              <router-link :to="`/camps/${camp.item.id}/majors`">
                <v-icon>mdi-open-in-app</v-icon>
              </router-link>
            </td>
            <td class="table__cell text-center">
              <router-link
                class="hovering mr-1 edit"
                :to="{
                  name: 'editCamp',
                  params: { id: camp.item.id }
                }"
                v-if="
                  permissions.includes('update_api_admin-panel_camps_{camp}')
                "
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="camps.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import { IndexData, UpdateData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { isEqual } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      camps: [],
      pagination: {},
      queries: {},
      loadingCamps: false,
      filter: {
        type: "",
        month: "",
        year: "",
        available: ""
      },
      availableArray: [{ name: "all" }, { name: "yes" }, { name: "no" }],
      months: [
        { num: "1" },
        { num: "2" },
        { num: "3" },
        { num: "4" },
        { num: "5" },
        { num: "6" },
        { num: "7" },
        { num: "8" },
        { num: "9" },
        { num: "10" },
        { num: "11" },
        { num: "12" }
      ],
      yearsList: [
        { year: "2000" },
        { year: "2001" },
        { year: "2002" },
        { year: "2003" },
        { year: "2004" },
        { year: "2005" },
        { year: "2006" },
        { year: "2007" },
        { year: "2008" },
        { year: "2009" },
        { year: "2010" },
        { year: "2011" },
        { year: "2012" },
        { year: "2013" },
        { year: "2014" },
        { year: "2015" },
        { year: "2016" },
        { year: "2017" },
        { year: "2018" },
        { year: "2019" },
        { year: "2020" },
        { year: "2021" },
        { year: "2022" },
        { year: "2023" },
        { year: "2024" },
        { year: "2025" },
        { year: "2026" },
        { year: "2027" },
        { year: "2028" },
        { year: "2029" },
        { year: "2030" }
      ],
      camp_locations: [],
      camp_types: [],
      drawer: null
    };
  },
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    // this.indexCamps();
    this.indexLocations();
    this.campsHeaders();
    this.indexTypes();
  },
  methods: {
    indexCamps(query) {
      this.loadingCamps = true;
      IndexData({ reqName: "camps", query })
        .then(res => {
          const { data, meta } = res.data;
          this.camps = data;
          this.loadingCamps = false;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexLocations() {
      IndexData({ reqName: `/locations` })
        .then(res => {
          const { data } = res.data;
          this.camp_locations = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexTypes() {
      IndexData({ reqName: `/camp-types` })
        .then(res => {
          const { data } = res.data;
          this.camp_types = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    campsHeaders() {
      const headersList = [
        "Shown",
        "Name",
        "Type",
        "Location",
        "Start Date",
        "End Date",
        "Online Payment",
        "Cash on Delivery",
        "Teams",
        "Majors",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    createCamp() {
      this.$route.push("/camps/create");
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    campVisiblity(camp) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          UpdateData({
            reqName: `camps`,
            data: {
              available: camp.item.available,
              available_only: "",
              _method: "PUT"
            },
            id: camp.item.id
          })
            .then(() => {})
            .catch(() => {})
            .finally(() => {});
        }
      });
    },
    filterMonths(month) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, month, page: 1 } });
    },
    filterYears(year) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, year, page: 1 } });
    },
    filterCamp(type) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, type, page: 1 } });
    },
    filterLocation(location) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, location, page: 1 } });
    },
    filterAvailability(available) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, available, page: 1 } });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filter[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    }
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.pagination.current_page = query.page;
        this.filter.month = query.month;
        this.filter.year = query.year;
        this.filter.available = query.available;
        if (query.type) {
          this.filter.type = Number(query.type);
        }
        if (query.location) {
          this.filter.location = Number(query.location);
        }
        this.indexCamps(query);
      },
      immediate: true
    }
  }
};
</script>
